import React from "react";
import { Provider } from "react-redux";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { store } from "./store/store";
import { AuthProvider } from "./hooks/useAuth";
import { ThemeProvider } from "./theme/ThemeContext";
import Navigation from "./components/Navigation/Navigation";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import AdminRoute from "./components/AdminRoute/AdminRoute";
import Login from "./pages/Login/Login";
import Main from "./pages/Main/Main";
import Users from "./pages/Users/Users";
import Units from "./pages/Units/Units";
import Personnel from "./pages/Personnel/Personnel";
import Items from "./pages/Items/Items";
import Inventory from "./pages/Inventory/Inventory";
import Signature from "./pages/Signature/Signature";
import EmployeeAssignmentPage from "./pages/EmployeeAssignment/EmployeeAssignmentPage";
import EmployeePagesManagement from "./pages/EmployeePagesManagement/EmployeePagesManagement";
import History from "./pages/History/History";
import Settings from "./pages/Settings/Settings";
import "./App.css";

function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
      <ThemeProvider>
      <Router unstable_useTransitions={false}>
        <div id="kesher-app" className="App">
          <Navigation />
          <div className="main-content-wrapper">
            <Routes>
              <Route path="/" element={<Login />} />
              <Route
                path="/ראשי"
                element={
                  <ProtectedRoute>
                    <Main />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/create-user"
                element={
                  <ProtectedRoute>
                    <AdminRoute>
                      <Users />
                    </AdminRoute>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/units"
                element={
                  <ProtectedRoute>
                    <Units />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/personnel"
                element={
                  <ProtectedRoute>
                    <Personnel />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/items"
                element={
                  <ProtectedRoute>
                    <Items />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/signature"
                element={
                  <ProtectedRoute>
                    <Signature />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/inventory"
                element={
                  <ProtectedRoute>
                    <Inventory />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/assignment/:pageId"
                element={<EmployeeAssignmentPage />}
              />
              <Route
                path="/employee-pages"
                element={
                  <ProtectedRoute>
                    <AdminRoute>
                      <EmployeePagesManagement />
                    </AdminRoute>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/history"
                element={
                  <ProtectedRoute>
                    <History />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <Settings />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </div>
      </Router>
      </ThemeProvider>
      </AuthProvider>
    </Provider>
  );
}

export default App;
